module.exports = __webpack_public_path__ + "img/calculator.41870b2d.svg";